/**
 * Selector to get the hasDismissedReductionMigrationModal flag for the currently active application
 */
import { isEqual } from 'es-toolkit';
import { createSelectorCreator, lruMemoize } from 'reselect';

import type { ApplicationFlagEntry } from '/business/shared/state/reducers/applicationFlags';
import getApplicationFlagsSelector from './getApplicationFlagsSelector';

const createDeepEqualSelector = createSelectorCreator(lruMemoize, isEqual);

export default createDeepEqualSelector(
  [getApplicationFlagsSelector],
  (applicationFlags: Partial<ApplicationFlagEntry> | null) => {
    return applicationFlags?.hasDismissedReductionMigrationModal;
  },
);
